export const assets = {
  logo: './assets/images/xploraLogo.png',
  adminIcon: 'assets/images/profile.png',
  placeHolderLogo: 'assets/images/placeholder.png',
  sidebarDashboardIcon: 'assets/images/dash.svg',
  viewIcon: 'assets/images/eye.svg',
  edit_icon: 'assets/images/edit_icon.svg',
  deleteIcon: 'assets/images/delete_icon.svg',
  RevenueIcon: 'assets/images/revenue.svg',
  ReveiwIcon: 'assets/images/rating.svg',
  CmsIcon: 'assets/images/cms.svg',
  LogoutIcon: 'assets/images/logout.svg',
  CategoryIcon: 'assets/images/category.svg',
  NotificationIcon: 'assets/images/notification.svg',
  ReportIcon: 'assets/images/reports.svg',
  searchIcon: 'assets/images/search_icon.svg',
  UsersIcon: 'assets/images/total_user.svg',
  VendorIcon: 'assets/images/vendor_icon.svg',
  ProductIcon: 'assets/images/product_icon.svg',
  OrderIcon: 'assets/images/order_icon.svg',
  AdIcon: 'assets/images/ad_icon.svg',
  AnalyticIcon: 'assets/images/analytic_icon.svg',
  CouponsIcon: 'assets/images/coupons_icon.svg',
  PropertyIcon: 'assets/images/building.png',
  ChatIcon: 'assets/images/chat.png',
  HouseIcon: 'assets/images/house.png',
  AdvertisementIcon: 'assets/images/advertising.png',
  PortfolioIcon: 'assets/images/briefcase.png',
  SubadminIcon: 'assets/images/sub-admin.png',
  LoyaltyIcon: 'assets/images/fidelity.png',
  QuestionMark: 'assets/images/reports_icon.svg',
  cameraIcon: 'assets/images/camera_icon.svg',
  restIcon: 'assets/images/rest_icon.svg',
  listIcon: 'assets/images/list_icon.png',
  ReviewIcon: 'assets/images/review.svg',
  SettingIcon: 'assets/images/setting.svg',
  MembershipIcon: 'assets/images/membership.svg',
  MerchantIcon: 'assets/images/merchants.svg',
  DealsIcon: 'assets/images/deals.svg',
  BookingIcon: 'assets/images/booking.svg',
  noDataFound: 'assets/images/Nodat-found.gif',
  AmenitiesIcon: 'assets/images/amenities.svg',
  AddPackageIcon: 'assets/images/add-package.svg',
  aedicon: 'assets/images/aed.svg',
  calender_icon: 'assets/images/calender_icon.svg',
  package_icon: 'assets/images/package.svg',
  DummyPackage: 'assets/images/pck.jpg',
  plusIcon:  'assets/images/plus.png',
  couponicon: 'assets/images/coupon.svg',
  travelicon:'assets/images/flight-takeoff.svg'

};
